import { Component, OnInit } from '@angular/core';
import { fromEvent } from "rxjs";
import { map, filter, tap } from "rxjs/operators";
@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss']
})
export class ScrollToTopComponent implements OnInit {
  
  showBackToTopButton = false;

  constructor() {}

  ngOnInit() {
    // Subscribe to the scroll event
    fromEvent(window, "scroll")
      .pipe(
        map(() => window.scrollY),
        filter(scrollY => scrollY > 400),
        tap(() => this.showBackToTopButton = true)
      )
      .subscribe();

    // Subscribe to the scroll event again to hide the button when the user scrolls to the top of the page
    fromEvent(window, "scroll")
      .pipe(
        map(() => window.scrollY),
        filter(scrollY => scrollY === 0),
        tap(() => this.showBackToTopButton = false)
      )
      .subscribe();
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
